import emailjs from '@emailjs/browser';

class EmailService {
  constructor() {
    this.serviceID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_iu1pcr9';
    this.templateID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'template_j4ofw34';
    this.publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'Kt1oMJVjPG8gG5lMh';
    
    if (this.publicKey) {
      emailjs.init(this.publicKey);
    }
  }

  async sendChatNotification(messageData) {
    try {
      if (!this.publicKey) return null;

      const templateParams = {
        subject: messageData.subject || 'New Chat Message',
        message: messageData.message,
        from_name: messageData.from_name || 'Website Visitor',
        reply_to: 'no-reply@rasachat.netlify.app',
        timestamp: new Date().toLocaleString(),
        to_email: 'dewiwarmus@gmail.com'
      };

      return await emailjs.send(this.serviceID, this.templateID, templateParams);
    } catch (error) {
      console.error('Email Error:', error);
      return null;
    }
  }
}

export const emailService = new EmailService();